import { memo, type ReactNode } from 'react';

import { type CreditAnalyticsParams } from '@air/analytics';

import { AgentProvider } from './providers/AgentProvider';
import { type GetAuthToken } from './types/subscriptions';

export type ChatProps = {
  agentUrl: string;
  children: ReactNode;
  firstName?: string;
  getAuthToken: GetAuthToken;
  canConsumeMoreCredits: boolean;
  resourceId: string;
  /** Called when resourceId is empty (draft mode). Must create the resource and return the real ID. */
  resolveResourceId?: () => Promise<string>;
  workspaceId: string;
  creditAnalyticsParams: CreditAnalyticsParams | null;
  onShowPlansModal?: () => void;
};

export const Chat = memo(
  ({
    agentUrl,
    canConsumeMoreCredits,
    children,
    firstName,
    getAuthToken,
    workspaceId,
    resourceId,
    creditAnalyticsParams,
    onShowPlansModal,
    resolveResourceId,
  }: ChatProps) => (
    <AgentProvider
      agentUrl={agentUrl}
      canConsumeMoreCredits={canConsumeMoreCredits}
      creditAnalyticsParams={creditAnalyticsParams}
      firstName={firstName}
      getAuthToken={getAuthToken}
      onShowPlansModal={onShowPlansModal}
      resolveResourceId={resolveResourceId}
      resourceId={resourceId}
      workspaceId={workspaceId}
    >
      {children}
    </AgentProvider>
  ),
);

Chat.displayName = 'Chat';
